import { IDistributionStatusFunctions } from "../types/enum.type";

export enum DistributionStatusEnum {
  Distributed = "Distribuído",
  Captured = "Capturado",
  Expired = "Expirado",
  Blocked = "Bloqueado",
}

const COLOR_MAP = {
  [DistributionStatusEnum.Distributed]: "#99D1A0",
  [DistributionStatusEnum.Captured]: "#FFE380",
  [DistributionStatusEnum.Expired]: "#F46B71",
  [DistributionStatusEnum.Blocked]: "#CCC",
};

export function getDistributionStatus(status: string): DistributionStatusEnum {
  const result = Object.values(DistributionStatusEnum).find(
    (v) => v.toLowerCase() === status.toLowerCase()
  );
  if (!result) throw new Error("invalid recipient status");
  return result;
}

export const DistributionStatus: IDistributionStatusFunctions = {
  getStatusBgColor: (status: DistributionStatusEnum) => {
    const distributionStatus = getDistributionStatus(status);
    return COLOR_MAP[distributionStatus];
  },
};
